<template>
  <div class="flex flex-col items-center justify-center gap-10">
    <div class="loading loading-spinner w-32"></div>
    <KonsolenkostLogo class="h-16 md:h-24" />
  </div>
</template>

<script setup lang="ts">
import KonsolenkostLogo from './KonsolenkostLogo.vue';
</script>
